import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Phone: (386) 864-9197</p>
          <p>Email: gardeniallc3@gmail.com</p>
          <p>Address: PO Box 243, Seville, FL 32190</p>
        </div>
        
        <div className="footer-section">
          <h3>Business Hours</h3>
          <p>Monday - Friday: 8AM - 6PM</p>
          <p>Saturday: 9AM - 4PM</p>
          <p>Sunday: Closed</p>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-of-service">Terms of Service</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Service Areas</h3>
          <p>
            <strong>Flagler County</strong> and <strong>Volusia County</strong>
          </p>
          <p>
            <strong>Palm Coast</strong>, <strong>Bunnell</strong>, <strong>Flagler Beach</strong>, 
            <strong>Ormond Beach</strong>, and <strong>Daytona Beach</strong>
          </p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Gardenia Landscaping LLC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 